export const engagementSdkAuthChangelogs = "/engagement/sdk_auth/changelogs";
